export default function CardHpIntro({title, image, description, backgroundColor = "#FFF2E7"}) {
    return (
        <div className="flex flex-column px-25 py-5 gap-2 keduall-card justify-content-start cards-hp-intro w-full h-full" style={{ backgroundColor: backgroundColor}}>
            <div className="flex flex-column justify-content-start gap-075">
                <div className="flex keduall-typography heading-h5-semibold-600">{title}</div>
                <div className="keduall-typography text-16-normal-400">{description}</div>
            </div>
            <div className="flex justify-content-end">
                <img src={image} className="flex justify-content-end" alt=""></img>
            </div>
        </div>
    )
}